"use client";

import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { validation, validationText } from "../../utils/constants.js";
import { useDispatch, useSelector } from "react-redux";
import {
  errorToast,
  formatDate,
  formatDateMonth,
  success,
} from "../../utils/helpers.js";
import ThemeInput from "../ThemeComponent/ThemeInput";
import ThemeSelect from "../ThemeComponent/ThemeSelect";
import { SimpleBasic, TextBasic } from "../ThemeComponent/ThemeText";
import { CrossIcon } from "../../configs/svg.js";

const ViewNotesModal = ({ setIsOpen, modalData }) => {
  const [selectedImage, setSelectedImage] = useState(null);
  const isLoading = useSelector((state) => state.loading); // Assuming you have a loading state in Redux
  const dispatch = useDispatch();
  const {
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  // Handle Image selection
  const handleImageChange = (event) => {
    setSelectedImage(event.target.files[0]);
  };

  // Submit handler with FormData
  const onSubmit = async (data) => {
    if (!selectedImage) {
      errorToast("Please select an image to upload.");
      return;
    }

    let formData = new FormData();
    formData.append("image", selectedImage);
    formData.append("firstname", data.firstname);
    formData.append("lastname", data.lastname);
    formData.append("mobile_no", data.mobile_no);
    formData.append("username", data.username);

    try {
    } catch (error) {
      errorToast(error.message || "Something went wrong. Please try again.");
    }
  };

  const halfLength = Math.floor(modalData?.description?.length / 2);
  const firstHalf = modalData?.description?.slice(0, halfLength);
  const secondHalf = modalData?.description?.slice(halfLength);

  return (
    <div className="edit-profile-content">
      <div className="d-flex mb-3 justify-content-between">
        <div className="d-flex flex-column align-items-start">
          <TextBasic text="Note:" />
          <SimpleBasic
            text={modalData?.notes || "-"}
            className={"mt-3 fw-semibold"}
          />
        </div>
      </div>
    </div>
  );
};

export default ViewNotesModal;
